export default __webpack_public_path__ + "static/media/Info.12dd3834.svg";